export default {"src":"/_next/static/media/Use Cases Background.8f79203c.svg","height":553,"width":1440,"blurWidth":0,"blurHeight":0};